import { render, staticRenderFns } from "./filter-selector-dropdown.vue?vue&type=template&id=63a66979&"
import script from "./filter-selector-dropdown.vue.ts?vue&type=script&lang=ts&"
export * from "./filter-selector-dropdown.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports